import waseminari from "../assets/waseminari.png";
import { images } from "../constants";
import hailmary from "../assets/hailmary.png";
import jesus from "../assets/jesus.png";
import hailmary3 from "../assets/hailmary3.png";
import { useTranslation } from "react-i18next";

const AlevelAdmission = () => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 px-4 lg:px-10 mt-0 dark:bg-gray-800">
      {/* First Portion */}
      <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
        <h1 className="text-3xl sm:text-xl lg:text-2xl text-center font-bold tracking-wide text-gray-900 dark:text-white mb-6">
          {t("schoolName")}{" "}
          <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text block mt-2">
            {t("schoolSub")}
          </span>
        </h1>
        <img
          src={images.visigalogo}
          alt="Visiga Seminary Logo"
          className="mt-4 w-40 h-auto rounded-full border-4 border-white dark:border-gray-700 shadow-md hover:scale-105 transition-transform duration-300"
        />
      </div>

      {/* Middle Portion */}
      <div className="lg:col-span-6 flex flex-col items-start text-left mt-1 lg:mt-5">
        <h1 className="text-2xl sm:text-2xl lg:text-2xl tracking-wide text-gray-900 dark:text-white">
          {t("admissionAlevel.title")}{" "}
          <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text">
            {t("admissionAlevel.subtitle")}
          </span>
        </h1>

        <div className="text-sm mt-4 text-gray-800 dark:text-gray-200">
          <ul className="list-disc pl-5 space-y-2">
            <li><strong>{t("admissionAlevel.condition1.title")}</strong> – {t("admissionAlevel.condition1.desc")}</li>
            <li><strong>{t("admissionAlevel.condition2.title")}</strong> – {t("admissionAlevel.condition2.desc")}</li>
            <li><strong>{t("admissionAlevel.condition3.title")}</strong> – {t("admissionAlevel.condition3.desc")}</li>
            <li>
              <strong>{t("admissionAlevel.condition4.title")}</strong> – {t("admissionAlevel.condition4.desc")}
              <ul className="list-disc pl-6 mt-5 space-y-1">
                <li>EGM</li>
                <li>HGE</li>
                <li>PCM</li>
                <li>PCB</li>
                <li>HGL</li>
              </ul>
            </li>
          </ul>
        </div>

        <h1 className="mt-6 text-2xl tracking-wide text-gray-900 dark:text-white">
          {t("admissionAlevel.formTitle")}{" "}
          <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text">
            {t("admissionAlevel.schoolSub")}
          </span>
        </h1>

        <p className="mt-4 text-sm text-gray-800 dark:text-gray-200 w-full">
          {t("admissionAlevel.formNote")}
        </p>

        <h1 className="mt-5">{t("admissionAlevel.formNote2")}</h1>

        <div className="flex flex-col items-start mt-2 lg:mt-5 text-sm text-left text-gray-800 dark:text-gray-200">
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>{t("admissionAlevel.locations.0")}</strong></li>
            <li><strong>{t("admissionAlevel.locations.1")}</strong></li>
            <li><strong>{t("admissionAlevel.locations.2")}</strong></li>
            
          </ul>
        </div>
      </div>

      {/* Third Portion */}
      <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
        <img
          src={hailmary3}
          alt="Hail Mary"
          className="w-full h-auto max-h-96 object-cover rounded-lg border-4 border-white dark:border-gray-700 shadow-md hover:scale-102 transition-transform duration-300"
        />
        <p className="mt-4 text-center text-gray-600 dark:text-gray-300 italic">
          {t("motherText")}
        </p>
      </div>
    </div>
  );
};

export default AlevelAdmission;
